import React, { useState } from 'react';
import { ThumbsDownIcon, ThumbsUpIcon } from 'lucide-react';

/** Thumbs up/down — Anna learns which suggestions help. */
export function Feedback() {
  const [value, setValue] = useState<'up' | 'down' | null>(null);
  const btn = (kind: 'up' | 'down') => {
    const active = value === kind;
    const Icon = kind === 'up' ? ThumbsUpIcon : ThumbsDownIcon;
    return <button type="button" aria-pressed={active} aria-label={kind === 'up' ? 'Nuttig' : 'Niet nuttig'} onClick={() => setValue(active ? null : kind)} className={`grid h-11 w-11 place-items-center rounded-full transition-colors duration-150 ${active ? 'bg-accent/15 text-accent' : 'text-ink-muted hover:bg-white/[0.07] hover:text-ink'}`} data-id="element-1460" data-mp="a88ij4b3fnhj">
        <Icon className="h-5 w-5" strokeWidth={1.75} data-id="element-1461" data-mp="tvy2wqgpalgq" />
      </button>;
  };
  return <div className="flex items-center" data-id="element-1462" data-mp="oxmsoemhu8xz">
      {btn('up')}
      {btn('down')}
    </div>;
}